/**
 * @ngdoc directive
 * @name tabs
 *
 * @description
 * Page tabs
 */
module.directive('tabs', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        link: function ($scope) {
            $scope.selected = 0;

            $scope.selectTab = function (index) {
                $scope.selected = index;
            };
        },
        template:
                '<div class="aqua-tabs" ng-style="{\'color\': content.field_theme_tabs.color_text, \'background-color\': content.field_theme_tabs.color_background}">' +
                '  <a ng-attr-name="{{content.nid}}"></a>' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-tabs--title" ng-style="{\'color\': content.field_theme_tabs.color_title}">{{content.field_title_visible_web}}</span></h2>' +

                '    <div class="grid grid-gutter" ng-if="content.field_image">' +

                '      <div class="aqua-tabs--description grid grid-gutter">' +
                '        <div class="aqua-tabs--description-picture grid-6 grid-12-s">' +
                '          <img class="aqua-tabs--description-image" aqua-src="{{content.field_image.src}}" alt="{{content.field_image.alt}}" />' +
                '        </div>' +
                '        <p class="aqua-tabs--description-chapo grid-6 grid-12-s">{{content.field_teaser}}</p>' +
                '      </div>' +

                '    </div>' +

                '    <ol class="aqua-tabs--tab-links grid-12 grid grid-gutter">' +
                '      <li class="aqua-tabs--tab-link grid-12-s" ' +
                '               ng-repeat="tab in content.field_onglets" ng-click="selectTab($index)" ' +
                '               ng-style="{\'color\': selected === $index ? content.field_theme_tabs.color_link : content.field_theme_tabs.color_subtitle}" ' +
                '               ng-class="{\'is-active\': selected === $index}">{{tab.field_titre}}</li>' +
                '    </ol>' +
                '    <div class="aqua-tabs--tab-container grid-12" ng-style="{\'border-color\': content.field_theme_tabs.color_lighttext}" ng-if="content.field_onglets.length">' +
                '      <div class="aqua-tabs--tab aqua-richtext" ng-repeat="tab in content.field_onglets" ng-show="selected === $index">' +
                '        <div ng-bind-html="tab.field_corps | trustAsHtml"></div>' +
                '        <div ng-repeat="accordeon in tab.field_accordeon">' +
                '          <accordion  label="{{ accordeon.field_title }}"> ' +
                '            <div class="aqua-internship--row grid">\n' +
                '              <div class="grid-12" ng-bind-html="accordeon.field_content | trustAsHtml"></div>\n' +
                '            </div>'+
                '          </accordion>' +
                '      </div>' +
                '      </div>' +
                '    </div>' +
                '  </div>' +
                '</div>'
    };
});